import { useBCMSContext } from "@bcm-dev/bcms-vite";
import ReceiveTokenView from "components/pages/SecurityTokenPage/components/ReceiveTokenView";
import EnterSecurityTokenView from "components/pages/SecurityTokenPage/components/EnterSecurityTokenView";

export default function CaptureManageCardSetPIN(props) {
    const { state } = useBCMSContext();
    const { branding } = state ?? {};
    const { options } = branding ?? {};
    
    const contactMethod = options ? options.security_token_contact_chw23.toLowerCase() : "both";

    if(contactMethod === "both") {
        return <ReceiveTokenView />
    }

    return <EnterSecurityTokenView selectionID={ contactMethod } />
}